import React, { Component } from 'react'

import PlayItem from './PlayItem'

import config from '../config'
import api from '../services'
import utils from '../utils'
const { $ } = utils,{ pvIds } = config

export default class HotFloor extends Component {
  constructor(props){
    super(props)
    this.state = {
      list: []
    }

    this.loadData = this.loadData.bind(this)
  }

  loadData(){
    api.getRedPacketMarketActivity()
        .then(data => {
          if(data.returncode === 0) this.setState({list: data.result})
        })
        .catch((err) => {
          $.toast({
            text: err.message,
            duration: 2000,
          })
        })
  }

  componentDidMount(){
    this.loadData()
  }
  
  render(){
    return(
      <div className={this.state.list.length?'':'fn-hide'}>
        <div className='title'>
          <span>玩转活动</span>
        </div>
        {
          this.state.list.map(
            item => <PlayItem key={Math.random()}
                              pvId={pvIds.play}
                              activity={item} />
          )
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PlayFloor.js